import { generateClient } from "aws-amplify/api";
const client = generateClient();
import { list_support_modules_masters } from "@/graphql/queries";

export default {
  data() {
    return {
      modulesList: [],
    };
  },
  methods: {
    async fetchModules() {
      try {
        const response = await client.graphql({
          query: list_support_modules_masters,
        });

        const rawPayload = response.data.list_support_modules_masters;
        const responseData =
          typeof rawPayload === "string" ? JSON.parse(rawPayload) : rawPayload;

        if (responseData.status == "SUCCESS" || responseData.success === true) {
          const data = responseData.data;
          this.modulesList = Array.isArray(data) ? data : [];
        } else {
          this.modulesList = [];
        }
      } catch (error) {
        console.error("Error fetching support modules:", error);
        this.modulesList = [];
      }
    },
  },
};
